import { NotebookPen } from "lucide-react";
import MemoirsSection from "../components/travel/MemoirsSection";

/* My Memoirs — standalone page: article intro + the memoirs manager. */
export default function Memoirs() {
  return (
    <div data-testid="memoirs-page">
      <section className="text-white" style={{ backgroundColor: "#312e81" }}>
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-12">
          <h1 className="font-heading font-900 text-4xl sm:text-5xl flex items-center gap-3">
            <NotebookPen className="w-10 h-10" /> My Memoirs
          </h1>
          <p className="text-lg italic text-indigo-200 mt-2" data-testid="memoirs-page-tagline">Every Moment Has a Story. Keep Yours.</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-5 lg:px-8 py-10">
        <article className="prose-sm max-w-none text-zinc-700 space-y-4 mb-4" data-testid="memoirs-article">
          <p>
            Life isn't remembered only through major vacations and faraway destinations. Some of our most
            treasured memories happen much closer to home — a morning hike, a family picnic, a birthday
            celebration, an evening with friends, a school or college reunion, a wedding, a festival, or an
            unexpected day that simply became special.
          </p>
          <p>
            <b>My Memoirs</b> gives you a personal place within TravelerPulse to capture these moments while
            they are still fresh. Record what happened, where you went, who joined you, and the little details
            you don't want to forget. Add photographs, videos, notes, locations, dates, links, invitations,
            programs, and other keepsakes to build a lasting record of the experience.
          </p>
          <p>
            Create memoirs for hikes, walks, picnics, parties, get-togethers, reunions, celebrations, festivals,
            concerts, sporting events, family occasions, day trips, special meals, milestones — or simply a
            memorable day.
          </p>
          <p>
            Over time, individual memories can become a personal timeline of your life experiences, organized by
            date, place, people, event, and category. AI can help turn your notes and selected photographs into a
            beautifully written memoir while keeping you in control of the story.
          </p>
          <p>
            Your memoirs can remain completely private, be shared selectively with family and friends, or — with
            your permission — be transformed into a polished story, photo journal, social post, or PDF that you
            can preserve and share.
          </p>
          <p className="font-700 text-indigo-900">
            Because photographs tell us what we saw, but our stories remind us why the moment mattered.
          </p>
        </article>
        <div className="border-t-2 border-indigo-200 pt-8">
          <MemoirsSection />
        </div>
        <p className="text-xs text-muted-foreground text-center mt-10 font-mono">
          TravelerPulse.pro™ — Explore • Plan • Share • Travel • Remember
        </p>
      </div>
    </div>
  );
}
